export const gdpr = {
  routes: [
    {
      path: "/data",
      component: () => import("../organization-data-view"),
    },
    {
      path: "/data-category",
      component: () => import("../organization-data-category-view"),
    },
  ],
};

export const workspace = {
  routes: [
    {
      path: "/workspace/library/data-category",
      component: () => import("../workspace-library-data-category-view"),
    },
    {
      path: "/workspace/library/data",
      component: () => import("../workspace-library-data-view"),
    },
  ],
};

export const management = {
  routes: [
  ],
};
